<main class="c-main">
  <div class="row">
    <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
      {{ erro }}
    </div>
  </div>
  <div class="mat-elevation-z8">
    <mat-card>
      <div class="wow-form-header">
        <div class="wow-form-header__icon"><mat-icon>badge</mat-icon></div>
        <mat-card-title>
          Perfil
          <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
        </mat-card-title>
      </div>

      <p *ngIf="carregando">Carregando...</p>

      <mat-card *ngIf="formulario && !carregando">
        <form [formGroup]="formulario" (ngSubmit)="submit()">
          <div class="row">
            <div class="col-1">
              <mat-form-field class="full-width" appearance="fill" class="w-100">
                <mat-label>Id</mat-label>
                <input matInput formControlName="id" readonly>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field class="full-width" appearance="fill" class="w-100">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="nome" style="text-transform: uppercase;" required>
              </mat-form-field>
            </div>
            <div class="col-5">
              <mat-form-field class="full-width" appearance="fill" class="w-100">
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="descricao" style="text-transform: uppercase;" required>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="full-width" appearance="fill" class="w-100">
                <mat-label>Ativo</mat-label>
                <mat-select formControlName="ativo" required>
                  <mat-option [value]="true">Sim</mat-option>
                  <mat-option [value]="false">Não</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group col-md-12">
              <div class="row border border-secondary-subtle p-3 m-0">
                <div *ngFor="let permissao of nomePermissoes" class="col-md-3">
                  <label>
                    <input type="checkbox"
                      [checked]="formulario.get('permissoes')?.value.includes(getPermissaoPorNome(permissao))"
                      (change)="togglePermissao(getPermissaoPorNome(permissao))">
                    {{ permissao }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" (click)="limparFormulario()" mat-stroked-button>
              <mat-icon>insert_drive_file</mat-icon> Limpar
            </button>
            <button [disabled]="!formulario.valid" mat-raised-button color="primary">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
        </form>
      </mat-card>
    </mat-card>
  </div>
</main>
